import React, { useMemo, useState } from 'react'
import { strings } from '@constants'
import { displayAmount } from '@utils'
import Switch from '../Switch'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'

const TYPE = {
	YESTERDAY: 'YESTERDAY',
	TODAY: 'TODAY',
	WEEKLY: 'WEEKLY',
}
const DispatchPlan = ({ YesterdayData, TodayData, WeeklyData }) => {
	const [status, setStatus] = useState(TYPE.YESTERDAY)
	const columns = useMemo(() => {
		return [
			{
				label: strings('id'),
				key: 'dispatch_plan_id',
				mobile: true,
			},
			{
				label: strings(['order', 'id']),
				key: 'order_id',
				mobile: true,
			},
			{
				label: strings('buyer'),
				key: 'buyer',
				mobile: true,
			},

			{
				label: strings('supplier'),
				key: 'supplier',
				mobile: false,
			},

			{
				label: strings('serviced', 'quantity'),
				key: (item) => (item?.serviced_quantity ? `${item?.serviced_quantity} ${strings('mt')} ` : '-'),
				mobile: false,
			},
			{
				label: strings(['price', 'per', 'kg']),
				key: (item) => (item?.price_per_kg ? `${displayAmount(item?.price_per_kg)}` : '-'),
				mobile: false,
			},
			{
				label: strings('status'),
				key: 'status',
				mobile: false,
			},
			{
				label: strings('payment', 'status'),
				key: 'payment_status',
				mobile: true,
			},
		]
	}, [])

	const _data = status === TYPE.YESTERDAY ? YesterdayData : status === TYPE.TODAY ? TodayData : WeeklyData

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Dispatch Plan</Heading>
				<Switch
					options={[
						{ label: strings('yesterday'), value: TYPE.YESTERDAY },
						{ label: strings('today'), value: TYPE.TODAY },
						{ label: strings('weekly'), value: TYPE.WEEKLY },
					]}
					value={status}
					onChange={setStatus}
				/>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={_data || []}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					onRowClick={() => {}}
					rowClickable={false}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default DispatchPlan
